<template>
  <div v-if="selectedPolicy">
    <div class="modal fade" role="dialog" ref="policycoverageareamodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Coverage Area Policy ({{ selectedPolicy.title }})</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- /.modal-header -->
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <!-- Start: Form -->
                  <div class="row cRow">
                    <div class="col-sm-12">
                      <div class="summary-error" v-if="$v.model.$error">
                        This form has errors
                      </div>
                      <form @submit.prevent="submit">
                        <button
                          type="button"
                          id="btn-map"
                          class="btn btn-default"
                          @click.prevent="openMapModal()"
                        >
                          <i class="ic-map"></i>
                          Select Coverage Area
                        </button>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label class="required">Location</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.stringLocation.$error,
                                }"
								name="location"
                                v-model="model.stringLocation"
                                :disabled="isViewOnly"
                                readonly
                              />
                              <small
                                class="form-text sts-danger"
                                v-if="isSubmitted && !$v.model.stringLocation.required"
                                >Location is required</small
                              >
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label class="required">Radius</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error': isSubmitted && $v.model.radius.$error,
                                }"
								name="radius"
                                v-model="model.radius"
                                :disabled="isViewOnly"
                                readonly
                                required
                              />
                              <div v-if="isSubmitted && $v.model.radius.$error">
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.radius.required"
                                  >Radius is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.radius.maxLength"
                                  >Min radius is
                                  {{ $v.model.radius.$params.minValue.min }}</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label class="required">
                                Rate
                                <span class="--grey50" v-if="selectedPolicy"
                                  >({{ selectedPolicy.providerCurrency }})</span
                                >
                              </label>
                              <input
                                type="number"
                                class="form-control"
                                :class="{
                                  'field-error': isSubmitted && $v.model.rate.$error,
                                }"
                                v-model="model.rate"
                                :disabled="isViewOnly"
                                step="any"
                              />
                              <div v-if="isSubmitted && $v.model.rate.$error">
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.rate.required"
                                  >Rate is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.rate.maxLength"
                                  >Min rate is
                                  {{ $v.model.rate.$params.minValue.min }}</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <label>Status</label>
                          <label class="cursor-pointer">
                            <input
                              type="checkbox"
                              class="control-checkbox"
                              v-model="model.isActive"
                              :disabled="isViewOnly"
                            />
                            <span class="pl-5 font-weight-normal v-align-middle">
                              {{ model.isActive ? "Active" : "Inactive" }}
                            </span>
                          </label>
                        </div>
                        <div
                          class="modal-footer"
                          v-if="!isViewOnly && (isAllowToCreate || isAllowToUpdate)"
                        >
                          <button
                            v-if="!isUpdate && isAllowToCreate"
                            type="submit"
                            class="btn btn-primary"
                          >
                            Create
                          </button>
                          <button
                            v-if="isUpdate && isAllowToDelete"
                            type="button"
                            class="btn btn-default"
                            @click.prevent="confirmDelete(selectedPolicy.id)"
                          >
                            Delete
                          </button>
                          <button
                            v-if="isUpdate && isAllowToUpdate"
                            type="submit"
                            class="btn btn-primary"
                          >
                            Update
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <!-- End: Form -->
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
          <!-- /.modal-body -->
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="mapmodal">
      <div class="modal-dialog modal-lg">
        <div class="modal-header modal-new" :class="{ update: isUpdate }">
          <div class="row">
            <div class="col-sm-10">
              <h4>Coverage Area</h4>
              <h6 v-if="model.modifiedDate">
                Last Updated: {{ model.modifiedDate.stringFullDate }}
              </h6>
            </div>
            <div class="col-sm-2">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <i class="ic-close"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="modal-content">
          <div class="modal-body">
            <div class="gmap-wrapper">
              <div class="pac-card" id="pac-card">
                <div id="pac-container">
                  <input id="pac-input" type="text" placeholder="Enter a location" />
                </div>
              </div>
              <div id="map"></div>
              <div id="gmap-custom-control" v-show="!isViewOnly">
                <button type="button" class="btn btn-default remove-location">
                  Reset
                </button>
                <button type="button" class="btn btn-default draw-geometry">Draw</button>
                <button type="button" class="btn btn-primary save-location">Apply</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import policyCoverageAreaService from "@/services/master/policy/policyCoverageAreaService.js";
import maverickMap from "@/plugins/google/map.js";

export default {
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
  },
  data() {
    return {
      isSubmitted: false,
      publicSettings: [],
      allPermissions: [],
      isViewOnly: false,
      map: null,
      selectedPolicy: null,
      model: {},
      isLoading: false,
      isUpdate: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        stringLocation: { required },
        radius: { required, minValue: minValue(0) },
        rate: { required, minValue: minValue(0) },
      },
    };
  },
  async created() {
    this.publicSettings = await this.$store.dispatch("setting/getAllPublic");

    // subscribe message
    this.$eventBus.$on("initializePolicyCoverageArea", this.initialize);
    this.$eventBus.$on("deletePolicyCoverageArea", this.deleteItem);
    this.$eventBus.$on("openPolicyCoverageAreaModal", this.openModal);
  },
  mounted() {
    $(this.$refs.policycoverageareamodal).on("hidden.bs.modal", this.closeModal);
    $(this.$refs.mapmodal).on("hidden.bs.modal", this.closeMapModal);
  },
  updated() {
    if (!this.map) {
      const defaultLatLng = this.$helper.extractSetting(
        this.publicSettings,
        "DefaultLatLng",
        "-6.17003832454938|106.81490242481232"
      );
      const latLng = defaultLatLng.split("|");
      const lat = parseFloat(latLng[0]);
      const lng = parseFloat(latLng[1]);

      // creates map instance
      this.map = new maverickMap({
        mapId: "map",
        lat: lat,
        lng: lng,
        autocomplete: true,
        confirmLocationCallback: this.confirmLocation,
        removeLocationCallback: this.removeLocation,
        drawGeometryCallback: (_) => {}, // empty callback
      });
      this.map.initialize();
    }
  },
  beforeDestroy() {
    this.$eventBus.$off("initializePolicyCoverageArea");
    this.$eventBus.$off("deletePolicyCoverageArea");
    this.$eventBus.$off("openPolicyCoverageAreaModal");
    document.querySelectorAll(".pac-container").forEach((element) => element.remove());
  },
  methods: {
    confirmLocation(coordinate) {
      this.model.radius = coordinate.rad;
      this.model.stringLocation = coordinate.lat + "," + coordinate.lng;
      this.model.location = {
        latitude: coordinate.lat,
        longitude: coordinate.lng,
      };

      // bind value to the HTML element
      document.getElementsByName("location")[0].value = this.model.stringLocation;
      document.getElementsByName("radius")[0].value = this.model.radius;

      this.closeMapModal();
      this.$notification.success("Location saved.", { title: "Success" });
    },
    removeLocation() {
      this.model.stringLocation = null;
      this.model.radius = null;
      this.model.rate = null;
      this.model.location = null;

      // bind value to the HTML element
      document.getElementsByName("location")[0].value = "";
      document.getElementsByName("radius")[0].value = "";
      if (document.getElementsByName("rate").length > 0) {
        document.getElementsByName("rate")[0].value = "";
      }

      this.$notification.success("Location removed.", { title: "Success" });
    },
    async initialize(policy) {
      try {
        this.isLoading = true;
        this.isViewOnly = !policy.isOwnInventory;
        this.selectedPolicy = policy;
        this.reset();

        const profile = await this.$store.dispatch("user/getProfile");
        const permissions = profile.services["PolicyCoverageArea"];
        if (permissions) {
          this.allPermissions = permissions;
        }

        if (this.isAllowToRead) {
          await this.getByPolicyId();
        }

        this.openModal();
      } finally {
        this.isLoading = false;
      }
    },
    openModal() {
      $(this.$refs.policycoverageareamodal).modal();
      $(this.$refs.policycoverageareamodal).css("overflow-y", "auto");
    },
    openMapModal(object) {
      this.resetValidations();
      $(this.$refs.mapmodal).modal({ backdrop: "static", keyboard: false });
      if (
        this.model.stringLocation !== null &&
        this.model.stringLocation !== undefined &&
        this.model.stringLocation !== "" &&
        this.model.radius !== null
      ) {
        let coordinates = this.model.stringLocation.split(",");
        this.map.setCircleCenter(
          new google.maps.LatLng(parseFloat(coordinates[0]), parseFloat(coordinates[1])),
          parseFloat(this.model.radius),
          true
        );
      }
    },
    closeModal() {
      this.resetValidations();
      this.model = {};
      $(this.$refs.policycoverageareamodal).modal("hide");
    },
    closeMapModal() {
      $(this.$refs.mapmodal).modal("hide");
      this.openModal();
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    reset() {
      this.isUpdate = false;
      this.resetValidations();
      this.model = {};
    },
    async getByPolicyId() {
      try {
        const response = await policyCoverageAreaService.getByPolicyId(
          this.selectedPolicy.id
        );
        if (response === null) {
          this.isUpdate = false;
          this.model = { isActive: true };
        } else {
          this.isUpdate = true;
          this.model = response;
          this.model.stringLocation = `${response.location.latitude},${response.location.longitude}`;
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    fixNumber() {
      // parse string to numeric (int/float)
      this.model.rate = parseFloat(this.model.rate);
      this.model.distance = parseInt(this.model.distance);
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        this.model.policyId = this.selectedPolicy.id;
        this.fixNumber();
        if (!this.isUpdate) {
          await policyCoverageAreaService.create(this.model);
          this.$notification.success("Successfully added.", { title: "Success" });
        } else {
          await policyCoverageAreaService.update(this.model);
          this.$notification.success("Successfully updated.", { title: "Success" });
        }
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(id) {
      this.closeModal();
      // publish message
      this.$eventBus.$emit("openPolicyDeleteModal", "policyCoverageArea", id);
    },
    async deleteItem(id) {
      try {
        this.isLoading = true;
        await policyCoverageAreaService.delete(id, this.selectedPolicy.id);
        this.$notification.success("Successfully deleted.", { title: "Success" });
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/policy/PolicyCoverageArea.vue